import React, { Component } from 'react'
import LeftNav from "../components/LeftNav"
import { ReactP5Wrapper } from "react-p5-wrapper";
import sketch from '../components/SketchTesto';

export default class Testo extends Component {
    render() {
        return(
            <div className="pageContainer">
                <LeftNav/>
                <div className="mainContent blackBg" style={{overflowY: "auto"}}>
                    <div>
                        <div className="collectionDiv">
                            <p className="collectionTitle">
                                Testo
                            </p>
                            <a href="https://www.artblocks.io/collection/0x9800005deb3cfaf80077dbe9b9004c0020c1d6c5-2" target="_blank" rel="noopener noreferrer">
                                Available on artblocks studio
                            </a>
                            <br/><br/>
                            <div id='svgWrapper' style={{justifyContent: 'center', display: 'flex'}}>
                                <ReactP5Wrapper sketch={sketch}/>
                            </div>
                            <br/><br/>
                            <p>
                                Finally we reach structure: the text. <i>"The proposition is a picture of reality. The proposition is a model of the reality as we think it is."</i>
                                Self-determination of language in a system that describes itself through a labyrinth of variable, ephemeral, ambiguous meanings. 
                                Every character that connects in words assumes a role that determines itself and its surroundings up to the entire system. 
                                And that's how systems and structure multiply, through small changes that transform mercury in gold.
                            </p>
                            <p>
                                Testo is the third chapter of <a href="/ricercasemica">Ricerc(a)semica</a>, a journey into form and meaning of language. 
                                The algorithm explores how characters combine into texts, with varying roles depending on the context and the other characters.
                                Emergence, something that is only of the whole and not within the parts.
                            </p>
                            <p>
                                Resolution agnostic, svg ready to be plotted, physicals available on request.
                            </p>
                            <br/><br/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}